import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { UnassignLoadFromLaneRequest } from '@/types';
import { QUERY_KEYS } from '../../queryKeys';
import { loadlanes } from '../LoadLanes';

export const useUnassignLoadFromLane = (siteId?: number, customerId?: number) =>
  useMutation({
    mutationFn: (data: UnassignLoadFromLaneRequest) =>
      loadlanes.unassignLoadFromLane(data),
    onSuccess: (response) => {
      if (!response.success) return;

      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.loadLanes, siteId, customerId],
      });
    },
  });
